import { IResource } from "../i18n";

const translation_es: IResource = {
    header_title: 'MEET | entrevistas sin problemas',
    header_menu_api: 'API',
    header_signup_text: 'Regístrate gratis',
    header_signin_text: 'Entrar',
    header_dashboard_text: 'Mi Panel',

    general_title_text: 'Entrevistas sin problemas',
    general_cta_text_one: 'Ahorra tiempo, dinero y tus nervios',
    general_cta_text_two: 'al organizar y llevar a cabo',
    general_cta_text_three: 'entrevistas de trabajo a distancia',
    general_cta_button: 'Pruébalo ahora gratis',
    general_cta_contact: 'Contacta: office@meet.rs',
    general_cta_consent_one: 'Este sitio utiliza cookies sólo para propósitos de análisis y personalización.',
    general_cta_consent_two: 'Al continuar usando este sitio, usted está de acuerdo con ',
    general_tos_text: 'Condiciones de uso',
    general_tos_tooltip: 'Vivani Meet Términos de Uso',
    general_cookies_text: 'Política de cookies',
    general_cookies_tooltip: 'Política de Vivani Meet Cookies',
    general_privacy_text: 'Política de privacidad',
    general_privacy_tooltip: 'Vivani Meet Política de privacidad',
    general_refund_text: 'Política de reembolso',
    general_refund_tooltip: 'Vivani Meet Política de Reembolso',

    usecase_title_head: 'Construido a medida para las entrevistas a distancia',
    usecase_title_subhead: 'Todo ha sido diseñado en base a las necesidades de entrevistas a distancia que los reclutadores y entrevistadores tienen hoy en día',
    usecase_interviewer_title: 'AMIGABLE CON EL ENTREVISTADOR',
    usecase_interviewer_subtitle: 'Biblioteca de tareas',
    usecase_interviewer_body: 'Prepara las tareas de la entrevista por adelantado y disfruta de la entrevista',
    usecase_interviewer_learnmore: 'Aprende más',
    usecase_interviewer_imgalt: 'Entrevista en la pizarra',
    usecase_collaboration_title: 'TRABAJAR JUNTOS',
    usecase_collaboration_subtitle: 'Construido para la colaboración',
    usecase_collaboration_body_one: 'Llama, codifica, dibuja, escribe...',
    usecase_collaboration_body_two: 'Todo junto, todo al mismo tiempo.',
    usecase_collaboration_learnmore: 'Aprende más',
    usecase_collaboration_imgalt: 'Entrevista en la pizarra',    
    usecase_recruiter_title: 'AMIGABLE CON EL RECLUTADOR',
    usecase_recruiter_subtitle: 'Haciendo el trabajo por ti',
    usecase_recruiter_body: 'Programación automática, toma de notas, recordatorios a los participantes, recogida de información...',
    usecase_recruiter_learnmore: 'Aprende más',
    usecase_recruiter_imgalt: 'Entrevista en la pizarra',    
    usecase_call_title: 'VIDEOLLAMADA GRUPAL DE ALTA DEFINICIÓN',
    usecase_call_subtitle: 'Con grabación y transcripción',
    usecase_call_body_one: 'Cero plugins, aplicaciones, instalaciones',
    usecase_call_body_two: '¡Sólo funciona en los navegadores modernos!',
    usecase_call_learnmore: 'Aprende más',
    usecase_call_imgalt: 'Entrevista en la pizarra',     

    footer_email_text: "Contáctenos",

    signout_menu_text: "Cerrar la sesión",
    me_menu_text: "Mi Meet",

    help_menu_text: "Ayuda",

    cta_nosignup_text: "No es necesario registrarse ni descargar nada.",

        
    // Change language
    language_selector_title: "Idioma",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "SER ANFITRIÓN DE UNA REUNIÓN",
    general_cta_text_all: "Ahorra tiempo, dinero y tus nervios al organizar y llevar a cabo entrevistas de trabajo a distancia",

    header_title_short: "Vivani Meet",
}

export default translation_es;